import Card from "./Card";
import React from "react";

const REGULATORS = [
  {
    abbr: "UMRA",
    name: "Uganda Microfinance Regulatory Authority",
    href: "https://www.umra.go.ug/",
    blurb: "Oversees money lending and microfinance",
  },
  {
    abbr: "URA",
    name: "Uganda Revenue Authority",
    href: "https://www.ura.go.ug/",
    blurb: "Tax registration and filings",
  },
  {
    abbr: "UNBS",
    name: "Uganda National Bureau of Standards",
    href: "https://www.unbs.go.ug/",
    blurb: "Standards and quality where they apply to our work",
  },
];

function Services() {
  return (
    <div className="containery services">
      <h2
        id="services"
        className="main-title text-center services-section-title"
      >
        OUR SERVICES
      </h2>
      <p className="services-section-lead text-center">
        We lend responsibly, we build software, and we support property
        listings. We stay inside Uganda&apos;s rules, and you can confirm our
        standing with UMRA, URA, and UNBS on their public channels.
      </p>
      <div className="card-cover">
        <div className="col-md-12">
          <div className="rowy services-cards-row">
            <div className="col-md-4 mb-2">
              <Card
                tag="Lending & finance ops"
                title="Finance & lending software"
                img="card2.png"
                text="We run lending alongside the software that supports it—products your staff understand and steps borrowers can follow. Whether it is a short-term need or business credit, we aim for fair pricing and as little red tape as the law allows."
                highlights={[
                  "Practices aligned with UMRA expectations",
                  "Clear products and straight paths for customers",
                  "Reports and controls your supervisors can follow",
                ]}
              />
            </div>
            <div className="col-md-4 mb-2">
              <Card
                tag="Build & run"
                title="Software engineering"
                img="card1.png"
                text="We are engineers who work across the stack: backends, front ends, mobile where needed, design, testing, and cloud ops. We can take a project from an idea to something your users rely on daily—then help you keep it fast, safe, and easy to change."
                highlights={[
                  "APIs, web apps, integrations, and cloud hosting",
                  "Interfaces people can actually use, including accessibility",
                  "rentalsug.com is one system we design, ship, and operate",
                ]}
              />
            </div>
            <div className="col-md-4 mb-2">
              <Card
                tag="Property & listings"
                title="Real estate & proptech"
                img="card3.png"
                text="We combine property work with software: helping people search, list, and close leases. Renstia Real Estate feeds rentalsug.com for homes in Uganda today, and we plan to widen coverage as we grow."
                highlights={[
                  "Listings, search, and help for tenants and landlords",
                  "Processes that match Ugandan norms and good practice",
                  "Room to connect to your existing tools and data",
                ]}
              />
            </div>
          </div>
        </div>
      </div>

      <section
        className="services-compliance"
        id="compliance"
        aria-labelledby="compliance-heading"
      >
        <div className="services-compliance-inner">
          <h3 id="compliance-heading" className="services-compliance-heading">
            Licences and how to check us
          </h3>
          <p className="services-compliance-lead">
            We hold the licences and registrations that fit what we do, and we
            keep renewals and filing up to date. If you need licence numbers,
            dates, or a short pack for a bank or a tender, ask us. What we give
            you should line up with what regulators publish in their{" "}
            <strong>lists of licensed institutions</strong> and their usual{" "}
            <strong>review cycles</strong>.
          </p>
          <ul className="regulator-badges">
            {REGULATORS.map((r) => (
              <li key={r.abbr} className="regulator-badge">
                <a
                  className="regulator-badge-link"
                  href={r.href}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="regulator-badge-abbr">{r.abbr}</span>
                  <span className="regulator-badge-name">{r.name}</span>
                  <span className="regulator-badge-blurb">{r.blurb}</span>
                </a>
              </li>
            ))}
          </ul>
          <p className="services-compliance-foot">
            Need paperwork for a partner check or a bid?{" "}
            <a className="services-compliance-mail" href="#contact">
              Email or call us
            </a>
            —we are used to sharing registration details when someone needs to
            verify who we are.
          </p>
        </div>
      </section>
    </div>
  );
}

export default Services;
